$ = jQuery.noConflict();

$(() => {

	$('.agd-c-homeHelpBlock__navItem a').on('click', function(event){
		event.preventDefault();
		var nav = $(this).parent().attr('id')
		var category = nav.replace('_nav_','_content_');
		$('.agd-c-homeHelpBlock__category').removeClass('agd-c-homeHelpBlock__category--active');
		$('.agd-c-homeHelpBlock__navItem').removeClass('agd-c-homeHelpBlock__navItem--active');
		$('#'+category).addClass('agd-c-homeHelpBlock__category--active');
		$('#'+nav).addClass('agd-c-homeHelpBlock__navItem--active');
	});

});